import React from 'react';
/**
 * Reusable iOS-style system status bar (44px height).
 * Defaults to dark icons; pass tone="light" for white icons over dark hero.
 */
export function StatusBar({
  tone = 'dark'
}: {
  tone?: 'dark' | 'light';
}) {
  const c = tone === 'light' ? '#FFFFFF' : '#1A1A1A';
  return <div className="relative h-[44px] w-full flex items-center justify-between px-6" style={{
    color: c
  }} data-id="element-662">
      <span style={{
      fontSize: 15,
      fontWeight: 600
    }} data-id="element-663">
        9:41
      </span>
      <div className="flex items-center gap-1.5" aria-hidden="true" data-id="element-664">
        <div className="flex items-end gap-[2px] h-3" data-id="element-665">
          <span className="w-[3px] h-[4px] rounded-[1px]" style={{
          backgroundColor: c
        }} data-id="element-666" />
          <span className="w-[3px] h-[6px] rounded-[1px]" style={{
          backgroundColor: c
        }} data-id="element-667" />
          <span className="w-[3px] h-[8px] rounded-[1px]" style={{
          backgroundColor: c
        }} data-id="element-668" />
          <span className="w-[3px] h-[10px] rounded-[1px]" style={{
          backgroundColor: c
        }} data-id="element-669" />
        </div>
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" data-id="element-670">
          <path d="M8 11.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z" fill={c} data-id="element-671" />
          <path d="M3.5 6.8a6.4 6.4 0 019 0" stroke={c} strokeWidth="1.4" strokeLinecap="round" data-id="element-672" />
          <path d="M1 4.3a10 10 0 0114 0" stroke={c} strokeWidth="1.4" strokeLinecap="round" data-id="element-673" />
        </svg>
        <div className="flex items-center" data-id="element-674">
          <div className="w-[22px] h-[11px] rounded-[3px] flex items-center p-[1px]" style={{
          border: `1px solid ${c}`
        }} data-id="element-675">
            <div className="h-full w-[16px] rounded-[1.5px]" style={{
            backgroundColor: c
          }} data-id="element-676" />
          </div>
          <div className="w-[1.5px] h-[4px] ml-[1px] rounded-r-[1px]" style={{
          backgroundColor: c
        }} data-id="element-677" />
        </div>
      </div>
    </div>;
}